export enum RESPONSE_FORGOT {
    CANTIDAD_REINTENTOS_SUPERADA = 1,
    CORREO_ENVIADO = 2,
}